import type { Tid } from "./private/tid.gen";
import type { Locale } from "./private/locale.gen";
import { Asset } from "assets.gen";

export { Tid } from "./private/tid.gen";
export type { Locale } from "./private/locale.gen";

let data: string[][] = [];
let localeIndex = 0;
let loaded = false;

export const LOCALES: Locale[] = [];
export const LOCALE_LABELS: string[] = [];

export function isLoaded(): boolean {
  return loaded;
}

export async function loadI18n(url?: string): Promise<void> {
  const response = await fetch(url ?? Asset.i18n);
  if (!response.ok) {
    console.error(`i18n: failed to load translations (${response.status})`);
    return;
  }
  const json: string[][] = await response.json();
  if (!Array.isArray(json) || json.length === 0) {
    console.error("i18n: invalid data format");
    return;
  }
  data = json;
  loaded = true;

  LOCALES.length = 0;
  LOCALE_LABELS.length = 0;
  for (const row of data) {
    LOCALES.push(row[0] as Locale);
    LOCALE_LABELS.push(row[1]);
  }

  if (localeIndex === 0 && LOCALES.length > 0) {
    localeIndex = 0;
  }
}

export function setLocale(locale: Locale): void {
  const idx = LOCALES.indexOf(locale);
  if (idx >= 0) localeIndex = idx;
}

export function currentLocale(): string {
  if (!loaded || LOCALES.length === 0) return "en";
  return LOCALES[localeIndex] ?? "en";
}

export function cycleLocale(): string {
  if (!loaded || LOCALES.length === 0) return "en";
  localeIndex = (localeIndex + 1) % LOCALES.length;
  return LOCALES[localeIndex];
}

export function detectLocale(systemLang: string): Locale {
  return systemLang.toLowerCase().split("-")[0] as Locale;
}

export function t(key: Tid): string {
  if (!loaded || !data[localeIndex]) return "";
  return data[localeIndex][key] ?? "";
}
